module.exports = __webpack_public_path__ + "img/logo_rg.60d3eead.png";